var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-animation",class:{ '--out': _vm.isOut }},[_c('img',{ref:"img",staticClass:"animation-content",attrs:{"src":_vm.showUrl}}),_c('div',{staticClass:"animation-num"},[_vm._v("×"+_vm._s(_vm.showNumCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }